/* eslint-disable max-len */
export const ConsentGetOnet = "/consent/onet";
export const ConsentOnetSave = "/consent/save/onet";
export const ConsentSave = "/consent/save";
export const Consent = { url: "/api/consent/%7Baction%7D", type: undefined as { action: string | number; } };
